export default __webpack_public_path__ + "static/media/compass.c8161d3e.svg";